import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/icons/trash.svg'
import _imports_1 from '@/assets/icons/icon-plus.svg'
import _imports_2 from '@/assets/icons/close.svg'
import _imports_3 from '@/assets/icons/copy.svg'


const _hoisted_1 = {
  key: 0,
  class: "spinner"
}
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "input-row" }
const _hoisted_4 = { class: "input-wr w-50" }
const _hoisted_5 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_6 = { class: "input-row" }
const _hoisted_7 = { class: "input-wr w-100" }
const _hoisted_8 = { class: "input-row" }
const _hoisted_9 = { class: "input-wr short" }
const _hoisted_10 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_11 = { class: "input-wr short" }
const _hoisted_12 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_13 = { class: "input-wr short" }
const _hoisted_14 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_15 = { class: "input-wr short" }
const _hoisted_16 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_17 = { class: "input-wr short" }
const _hoisted_18 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_19 = { class: "input-row" }
const _hoisted_20 = { class: "input-wr short" }
const _hoisted_21 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_22 = { class: "input-wr short" }
const _hoisted_23 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_24 = { class: "input-wr short" }
const _hoisted_25 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_26 = { class: "input-row" }
const _hoisted_27 = { class: "input-wr" }
const _hoisted_28 = ["value", "onChange"]
const _hoisted_29 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_30 = { class: "perSQM-wr" }
const _hoisted_31 = { class: "input-wr" }
const _hoisted_32 = { class: "card card-mt" }
const _hoisted_33 = { class: "features-list" }
const _hoisted_34 = { class: "input-wr" }
const _hoisted_35 = ["onUpdate:modelValue", "onInput"]
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { class: "feature-row add-feature" }
const _hoisted_38 = { class: "input-wr" }
const _hoisted_39 = { class: "card card-mt" }
const _hoisted_40 = { class: "input-row" }
const _hoisted_41 = { class: "card card-mt" }
const _hoisted_42 = { class: "images-list-wr" }
const _hoisted_43 = { class: "label" }
const _hoisted_44 = { class: "images-main-wr" }
const _hoisted_45 = { class: "image-section-wr" }
const _hoisted_46 = { class: "image-section" }
const _hoisted_47 = { class: "image-fields" }
const _hoisted_48 = {
  key: 0,
  class: "input-wr"
}
const _hoisted_49 = ["value", "onChange"]
const _hoisted_50 = {
  key: 1,
  class: "input-wr"
}
const _hoisted_51 = ["value", "onChange"]
const _hoisted_52 = ["value", "onChange"]
const _hoisted_53 = {
  key: 2,
  class: "input-wr"
}
const _hoisted_54 = ["value", "onChange"]
const _hoisted_55 = {
  key: 0,
  class: "image-remove-wr"
}
const _hoisted_56 = ["onClick"]
const _hoisted_57 = ["src"]
const _hoisted_58 = {
  key: 1,
  class: "upload-image-wr"
}
const _hoisted_59 = { class: "upload-image-button-wr" }
const _hoisted_60 = ["for"]
const _hoisted_61 = {
  key: 0,
  class: "spinner spinner-small"
}
const _hoisted_62 = ["id", "onChange"]
const _hoisted_63 = {
  key: 0,
  class: "upload-image-wr"
}
const _hoisted_64 = { class: "upload-image-button-wr" }
const _hoisted_65 = {
  key: 0,
  class: "spinner spinner-small"
}
const _hoisted_66 = { class: "image-and-data-actions" }
const _hoisted_67 = ["onClick"]
const _hoisted_68 = { class: "card card-mt" }
const _hoisted_69 = { class: "select-facade-wr" }
const _hoisted_70 = { class: "facade-options-wr" }
const _hoisted_71 = { class: "card card-mt" }
const _hoisted_72 = { class: "select-facade-wr" }
const _hoisted_73 = { class: "facade-options-wr" }
const _hoisted_74 = { class: "card card-mt" }
const _hoisted_75 = { class: "select-inclusion-wr" }
const _hoisted_76 = { class: "inclusion-options-wr" }
const _hoisted_77 = {
  key: 0,
  class: "input-wr"
}
const _hoisted_78 = ["value", "onChange"]
const _hoisted_79 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_80 = { class: "card card-mt" }
const _hoisted_81 = { class: "select-facade-wr" }
const _hoisted_82 = { class: "facade-options-wr" }
const _hoisted_83 = { class: "card card-mt" }
const _hoisted_84 = { class: "select-facade-wr" }
const _hoisted_85 = { class: "home-design-url-wrapper" }
const _hoisted_86 = { class: "input-wr url-input-wr" }
const _hoisted_87 = ["value"]
const _hoisted_88 = { class: "input-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[48] || (_cache[48] = _createElementVNode("div", { class: "dashboard-header" }, [
      _createElementVNode("h2", { class: "title-main" }, "Update House Design")
    ], -1)),
    ($setup.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : (_openBlock(), _createElementBlock("form", {
          key: 1,
          class: "default-form",
          onSubmit: _cache[19] || (_cache[19] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _cache[24] || (_cache[24] = _createElementVNode("label", { class: "label" }, "Design Name", -1)),
                _withDirectives(_createElementVNode("input", {
                  class: "input",
                  placeholder: "Design Name",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.form.name) = $event))
                }, null, 512), [
                  [_vModelText, $setup.form.name]
                ]),
                ($setup.v$.name.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString($setup.v$.name.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[25] || (_cache[25] = _createElementVNode("label", { class: "label" }, "Description", -1)),
                _withDirectives(_createElementVNode("textarea", {
                  class: "input textarea-input",
                  placeholder: "House description",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.form.description) = $event))
                }, null, 512), [
                  [_vModelText, $setup.form.description]
                ])
              ])
            ]),
            _cache[29] || (_cache[29] = _createElementVNode("div", { class: "house-subtitle" }, [
              _createElementVNode("label", { class: "label" }, "Configuration:")
            ], -1)),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _withDirectives(_createElementVNode("input", {
                  class: "input",
                  placeholder: "Beds",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.form.bedroom) = $event)),
                  type: "number"
                }, null, 512), [
                  [_vModelText, $setup.form.bedroom]
                ]),
                ($setup.v$.bedroom.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString($setup.v$.bedroom.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _withDirectives(_createElementVNode("input", {
                  class: "input",
                  placeholder: "Baths",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.form.bathroom) = $event)),
                  type: "number"
                }, null, 512), [
                  [_vModelText, $setup.form.bathroom]
                ]),
                ($setup.v$.bathroom.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString($setup.v$.bathroom.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _withDirectives(_createElementVNode("input", {
                  class: "input",
                  placeholder: "Cars",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.form.garage) = $event)),
                  type: "number"
                }, null, 512), [
                  [_vModelText, $setup.form.garage]
                ]),
                ($setup.v$.garage.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString($setup.v$.garage.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _withDirectives(_createElementVNode("input", {
                  class: "input",
                  placeholder: "Living",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.form.loungeRoom) = $event)),
                  type: "number"
                }, null, 512), [
                  [_vModelText, $setup.form.loungeRoom]
                ]),
                ($setup.v$.loungeRoom.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString($setup.v$.loungeRoom.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _withDirectives(_createElementVNode("input", {
                  class: "input",
                  placeholder: "Storeys",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.form.storey) = $event)),
                  type: "number"
                }, null, 512), [
                  [_vModelText, $setup.form.storey]
                ]),
                ($setup.v$.storey.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString($setup.v$.storey.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _cache[30] || (_cache[30] = _createElementVNode("div", { class: "house-subtitle" }, [
              _createElementVNode("label", { class: "label" }, "Dimensions")
            ], -1)),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _withDirectives(_createElementVNode("input", {
                  class: "input",
                  placeholder: "Area",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.form.area) = $event)),
                  type: "number",
                  step: "any"
                }, null, 512), [
                  [_vModelText, $setup.form.area]
                ]),
                ($setup.v$.area.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString($setup.v$.area.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_22, [
                _withDirectives(_createElementVNode("input", {
                  class: "input",
                  placeholder: "Width",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.form.width) = $event)),
                  type: "number",
                  step: "any"
                }, null, 512), [
                  [_vModelText, $setup.form.width]
                ]),
                ($setup.v$.width.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString($setup.v$.width.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_24, [
                _withDirectives(_createElementVNode("input", {
                  class: "input",
                  placeholder: "Length",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.form.length) = $event)),
                  type: "number",
                  step: "any"
                }, null, 512), [
                  [_vModelText, $setup.form.length]
                ]),
                ($setup.v$.length.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString($setup.v$.length.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _cache[26] || (_cache[26] = _createElementVNode("label", { class: "label" }, "Base Price", -1)),
                _createElementVNode("input", {
                  class: "input",
                  placeholder: "$350,000",
                  value: $setup.formatPriceTrim($setup.form?.basePrice),
                  onChange: (e) => $setup.updatePriceInput(e, $setup.form, 'basePrice')
                }, null, 40, _hoisted_28),
                ($setup.v$.basePrice.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString($setup.v$.price.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _cache[27] || (_cache[27] = _createElementVNode("label", { class: "label" }, "Per Square Metre", -1)),
                  _withDirectives(_createElementVNode("input", {
                    class: "input perSQM-input",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.perSQM) = $event)),
                    type: "text",
                    disabled: ""
                  }, null, 512), [
                    [_vModelText, $setup.perSQM]
                  ])
                ]),
                _cache[28] || (_cache[28] = _createElementVNode("div", { class: "perSQM-text" }, "per SQM", -1))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_32, [
            _cache[33] || (_cache[33] = _createElementVNode("h4", { class: "subtitle-main" }, "Add Features", -1)),
            _createElementVNode("div", _hoisted_33, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.houseFeatures, (feature, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "feature-row",
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_34, [
                    _withDirectives(_createElementVNode("input", {
                      class: "input",
                      "onUpdate:modelValue": ($event: any) => ((feature.name) = $event),
                      onInput: ($event: any) => ($setup.updateFeatureText(index, feature.name))
                    }, null, 40, _hoisted_35), [
                      [_vModelText, feature.name]
                    ])
                  ]),
                  _createElementVNode("div", {
                    class: "delete-feature",
                    onClick: ($event: any) => ($setup.removeFeature(index))
                  }, [...(_cache[31] || (_cache[31] = [
                    _createElementVNode("img", {
                      src: _imports_0,
                      alt: "delete"
                    }, null, -1)
                  ]))], 8, _hoisted_36)
                ]))
              }), 128)),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _withDirectives(_createElementVNode("input", {
                    class: "input",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.newFeature) = $event)),
                    placeholder: "Type Feature"
                  }, null, 512), [
                    [_vModelText, $setup.newFeature]
                  ])
                ]),
                _createElementVNode("div", {
                  class: "add-feature-btn",
                  onClick: $setup.addNewFeature
                }, [...(_cache[32] || (_cache[32] = [
                  _createElementVNode("img", {
                    src: _imports_1,
                    alt: "add"
                  }, null, -1)
                ]))])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_39, [
            _cache[34] || (_cache[34] = _createElementVNode("h4", { class: "subtitle-main" }, "Categorized Inclusions", -1)),
            _createElementVNode("div", _hoisted_40, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.inclusionCategories, (category) => {
                return _createVNode($setup["ListItemGenerator"], {
                  key: category.key,
                  itemName: category.label,
                  existingItems: $setup.categorizedInclusionsMap[category.key],
                  onItemChanged: (items) => $setup.updateCategorizedInclusions(category.key, items)
                }, null, 8, ["itemName", "existingItems", "onItemChanged"])
              }), 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_41, [
            _cache[41] || (_cache[41] = _createElementVNode("h4", { class: "subtitle-main" }, "Gallery", -1)),
            _createElementVNode("div", _hoisted_42, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.imagesToRender, (image) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: image.type
                }, [
                  _createElementVNode("label", _hoisted_43, _toDisplayString(image.label), 1),
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("div", _hoisted_45, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(image.data, ({ id, url }, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "image-wr",
                          key: index
                        }, [
                          _createElementVNode("div", _hoisted_46, [
                            _createElementVNode("figure", _hoisted_47, [
                              ($setup.validsImagesNameInputs.includes(image.type))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                    _createElementVNode("input", {
                                      class: "input name-picker",
                                      placeholder: "Name",
                                      value: $setup.form[image.type].find((el) => el.id === id).name,
                                      onChange: ($event: any) => ($setup.onNameChange(image.type, id, $event.target.value))
                                    }, null, 40, _hoisted_49)
                                  ]))
                                : _createCommentVNode("", true),
                              ($setup.validImagesColorInputs.includes(image.type))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                    _createElementVNode("input", {
                                      class: "color-picker",
                                      type: "color",
                                      value: $setup.form[image.type].find((el) => el.id === id).color,
                                      onChange: ($event: any) => ($setup.onColorChange(image.type, id, $event.target.value))
                                    }, null, 40, _hoisted_51),
                                    _createElementVNode("input", {
                                      class: "input",
                                      placeholder: "#000000",
                                      value: $setup.form[image.type].find((el) => el.id === id).color,
                                      onChange: ($event: any) => ($setup.onColorChange(image.type, id, $event.target.value))
                                    }, null, 40, _hoisted_52)
                                  ]))
                                : _createCommentVNode("", true),
                              (image.type === $setup.ImagesHouseTypes.FACADES)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                    _createElementVNode("input", {
                                      class: "input price-picker",
                                      placeholder: "Price",
                                      type: "number",
                                      value: $setup.form[image.type].find((el) => el.id === id).price,
                                      onChange: ($event: any) => ($setup.onPriceChange(image.type, id, $event.target.value))
                                    }, null, 40, _hoisted_54)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            url
                              ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                  url
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: "remove-image",
                                        onClick: ($event: any) => ($setup.onRemoveImage(image.type, id))
                                      }, [...(_cache[35] || (_cache[35] = [
                                        _createElementVNode("img", {
                                          src: _imports_2,
                                          alt: "close"
                                        }, null, -1)
                                      ]))], 8, _hoisted_56))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("img", { src: url }, null, 8, _hoisted_57)
                                ]))
                              : _createCommentVNode("", true),
                            ($setup.showUploadButton(image.type, index))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                  _createElementVNode("div", _hoisted_59, [
                                    _createElementVNode("label", {
                                      class: _normalizeClass(["upload-image-button", { disabled: $setup.isUploadingImage }]),
                                      for: `file-upload${id}`
                                    }, [
                                      _cache[36] || (_cache[36] = _createElementVNode("img", {
                                        src: _imports_1,
                                        alt: "uploadImage"
                                      }, null, -1)),
                                      _cache[37] || (_cache[37] = _createElementVNode("p", null, "Upload image", -1)),
                                      ($setup.isUploadingImage)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_61))
                                        : _createCommentVNode("", true)
                                    ], 10, _hoisted_60)
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("input", {
                            class: "input-file-upload-image",
                            id: `file-upload${id}`,
                            type: "file",
                            onClick: _cache[12] || (_cache[12] = ($event: any) => ($event.target.value = '')),
                            onChange: ($event: any) => ($setup.onUploadImage($event, image.type, id)),
                            accept: "image/*"
                          }, null, 40, _hoisted_62)
                        ]))
                      }), 128)),
                      (image.type === $setup.ImagesHouseTypes.MAIN_IMAGE && (!image.data || image.data.length === 0))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                            _createElementVNode("div", _hoisted_64, [
                              _createElementVNode("label", {
                                class: _normalizeClass(["upload-image-button", { disabled: $setup.isUploadingImage }]),
                                for: `file-upload-empty`
                              }, [
                                _cache[38] || (_cache[38] = _createElementVNode("img", {
                                  src: _imports_1,
                                  alt: "uploadImage"
                                }, null, -1)),
                                _cache[39] || (_cache[39] = _createElementVNode("p", null, "Upload main image (empty state)", -1)),
                                ($setup.isUploadingImage)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_65))
                                  : _createCommentVNode("", true)
                              ], 2)
                            ]),
                            _createElementVNode("input", {
                              class: "input-file-upload-image",
                              id: `file-upload-empty`,
                              type: "file",
                              onClick: _cache[13] || (_cache[13] = ($event: any) => ($event.target.value = '')),
                              onChange: _cache[14] || (_cache[14] = ($event: any) => ($setup.onUploadImage($event, $setup.ImagesHouseTypes.MAIN_IMAGE, $setup.uuidv4()))),
                              accept: "image/*"
                            }, null, 32)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_66, [
                        ($setup.validsMultipleImagesInputs.includes(image.type))
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "add-image-button-wr",
                              onClick: ($event: any) => ($setup.addImage(image.type))
                            }, [...(_cache[40] || (_cache[40] = [
                              _createElementVNode("img", {
                                class: "button-pointer",
                                src: _imports_1,
                                alt: "addImage"
                              }, null, -1)
                            ]))], 8, _hoisted_67))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_68, [
            _createElementVNode("div", _hoisted_69, [
              _cache[42] || (_cache[42] = _createElementVNode("label", { class: "label" }, "Select Facades", -1)),
              _createElementVNode("div", _hoisted_70, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredFacades, (facade) => {
                  return (_openBlock(), _createBlock($setup["CheckboxInput"], {
                    label: facade.name,
                    modelValue: $setup.form.facades.includes(facade._id),
                    class: _normalizeClass('facade-item'),
                    "onUpdate:modelValue": ($event: any) => ($setup.updateFacades(facade))
                  }, null, 8, ["label", "modelValue", "onUpdate:modelValue"]))
                }), 256))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_71, [
            _createElementVNode("div", _hoisted_72, [
              _cache[43] || (_cache[43] = _createElementVNode("label", { class: "label" }, "Select Internal Colour Schemes", -1)),
              _createElementVNode("button", {
                class: "button default outlined",
                type: "button",
                onClick: _cache[15] || (_cache[15] = ($event: any) => ($setup.isInternalSchemeModalOpen = true))
              }, "Add Scheme"),
              _createElementVNode("div", _hoisted_73, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.internalColorSchemes, (color) => {
                  return (_openBlock(), _createBlock($setup["CheckboxInput"], {
                    label: color.name,
                    modelValue: $setup.form.internalColorSchemes.includes(color._id),
                    class: _normalizeClass('internal-color-item'),
                    "onUpdate:modelValue": ($event: any) => ($setup.updateInternalColorSchemes(color))
                  }, null, 8, ["label", "modelValue", "onUpdate:modelValue"]))
                }), 256))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_74, [
            _createElementVNode("div", _hoisted_75, [
              _cache[44] || (_cache[44] = _createElementVNode("label", { class: "label" }, "Set Inclusions Range Prices", -1)),
              _createElementVNode("button", {
                class: "button default outlined",
                type: "button",
                onClick: _cache[16] || (_cache[16] = ($event: any) => ($setup.isInclusionModalOpen = true))
              }, "Add Inclusion"),
              _createElementVNode("div", _hoisted_76, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.inclusions, (inclusion) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "inclusion-option-item",
                    key: inclusion._id
                  }, [
                    _createVNode($setup["CheckboxInput"], {
                      label: inclusion.type,
                      modelValue: $setup.form.inclusions.includes(inclusion._id),
                      class: _normalizeClass('inclusion-item'),
                      "onUpdate:modelValue": ($event: any) => ($setup.updateInclusions(inclusion))
                    }, null, 8, ["label", "modelValue", "onUpdate:modelValue"]),
                    ($setup.form.inclusions.includes(inclusion._id))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                          _createElementVNode("input", {
                            class: "input",
                            placeholder: "$350,000",
                            value: $setup.formatPriceTrim($setup.form.inclusionPrices[inclusion._id]),
                            onChange: (e) => $setup.updatePriceInput(e, $setup.form.inclusionPrices, inclusion._id)
                          }, null, 40, _hoisted_78),
                          ($setup.form.inclusions.includes(inclusion._id) && $setup.form.inclusionPrices[inclusion._id] < 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_79, "Price must be greater than 0"))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_80, [
            _createElementVNode("div", _hoisted_81, [
              _cache[45] || (_cache[45] = _createElementVNode("label", { class: "label" }, "Select Upgrades / Promotions", -1)),
              _createElementVNode("button", {
                class: "button default outlined",
                type: "button",
                onClick: _cache[17] || (_cache[17] = ($event: any) => ($setup.isOptionalUpgradeModalOpen = true))
              }, "Add Upgrade"),
              _createElementVNode("div", _hoisted_82, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.optionalUpgrades, (optionalUpgrade) => {
                  return (_openBlock(), _createBlock($setup["CheckboxInput"], {
                    label: optionalUpgrade.name,
                    modelValue: $setup.form.optionalUpgrades.includes(optionalUpgrade._id),
                    class: _normalizeClass('optional-upgrade-item'),
                    "onUpdate:modelValue": ($event: any) => ($setup.updateOptionalUpgrades(optionalUpgrade))
                  }, null, 8, ["label", "modelValue", "onUpdate:modelValue"]))
                }), 256))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_83, [
            _createElementVNode("div", _hoisted_84, [
              _cache[47] || (_cache[47] = _createElementVNode("label", { class: "label" }, "Home Design URL", -1)),
              _createElementVNode("div", _hoisted_85, [
                _createElementVNode("div", _hoisted_86, [
                  _createElementVNode("input", {
                    class: "input url-input",
                    type: "text",
                    value: $setup.homeDesignUrl,
                    readonly: ""
                  }, null, 8, _hoisted_87)
                ]),
                _createElementVNode("div", { class: "copy-button-wr" }, [
                  _createElementVNode("button", {
                    class: "copy-button",
                    onClick: $setup.copyToClipboard
                  }, [...(_cache[46] || (_cache[46] = [
                    _createElementVNode("img", {
                      src: _imports_3,
                      alt: "copy"
                    }, null, -1)
                  ]))])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_88, [
            _createElementVNode("button", {
              class: "button default primary create-btn",
              onClick: $setup.onUpdateHouse,
              type: "button"
            }, "Update"),
            _createElementVNode("button", {
              class: "button default outlined cancel-btn",
              onClick: _cache[18] || (_cache[18] = ($event: any) => ($setup.router.go(-1))),
              type: "button"
            }, "Cancel")
          ])
        ], 32)),
    _createVNode($setup["AddAndUpdateAssetInGalleryModal"], {
      isOpen: $setup.isInternalSchemeModalOpen,
      builderId: $setup.builderId,
      formType: $setup.AssetGalleryFormType.INTERNAL_COLOR_SCHEME,
      title: "Internal Color Scheme",
      uploadImage: "colorScheme/uploadImage",
      mode: "create",
      onClose: _cache[20] || (_cache[20] = ($event: any) => ($setup.isInternalSchemeModalOpen = false)),
      onCreateInternalColorScheme: $setup.handleCreateInternalColorScheme
    }, null, 8, ["isOpen", "builderId", "formType"]),
    _createVNode($setup["AddAndUpdateInclusionModal"], {
      isOpen: $setup.isInclusionModalOpen,
      builderId: $setup.builderId,
      mode: "create",
      onClose: _cache[21] || (_cache[21] = ($event: any) => ($setup.isInclusionModalOpen = false)),
      onCreateInclusion: $setup.handleCreateInclusion
    }, null, 8, ["isOpen", "builderId"]),
    _createVNode($setup["AddAndUpdateAssetInGalleryModal"], {
      isOpen: $setup.isOptionalUpgradeModalOpen,
      builderId: $setup.builderId,
      formType: $setup.AssetGalleryFormType.OPTIONAL_UPGRADE,
      title: "Optional Upgrade",
      uploadImage: "optionalUpgrade/uploadImagesOptionalUpgrade",
      mode: "create",
      onClose: _cache[22] || (_cache[22] = ($event: any) => ($setup.isOptionalUpgradeModalOpen = false)),
      onCreateOptionalUpgrade: $setup.handleCreateOptionalUpgrade
    }, null, 8, ["isOpen", "builderId", "formType"]),
    _createVNode($setup["ImageCropperModal"], {
      isOpen: $setup.isCropperModalOpen,
      image: $setup.imageToUpload.data,
      onOnCropImage: $setup.onCropImage,
      onClose: _cache[23] || (_cache[23] = ($event: any) => ($setup.isCropperModalOpen = false))
    }, null, 8, ["isOpen", "image"])
  ], 64))
}